module.exports = __webpack_public_path__ + "img/kimono.bcf0e14a.jpg";